// Предупреждението „масата е заета от резервация" в Маркиране — чиста логика
// без React (тестове: tableReservationNotice.test.ts). Показва се като модал с
// „Отказ"/„Продължи" (`ReservationConfirmModal`); „Продължи" пуска действието.

import type { TFunction } from "i18next";
import type { TableNameCheck, TableReservationNotice } from "../../../../../api/bills";

/**
 * За коя резервация да се пита при отваряне/смяна на маса с това име.
 * Вече отворена маса (`exists`) не се пита — нищо ново не се отваря: при
 * „Нова маса" това е грешка „заета", при разделяне — прехвърляне към нея.
 */
export const reservationToConfirm = (check: TableNameCheck): TableReservationNotice | null =>
  check.exists ? null : check.reservation;

const pad = (value: number) => String(value).padStart(2, "0");

/** „19:05" — локалният час на терминала (заведението е в същата зона). */
const clockOf = (iso: string) => {
  const date = new Date(iso);
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/**
 * „Маса 2 е заета от резервацията на Иванов (настанени 19:05)" /
 * „Маса 2 е резервирана за 19:30 — Иванов, 4 гости".
 */
export const tableReservationNoticeText = (
  tableName: string,
  notice: TableReservationNotice,
  t: TFunction,
): string =>
  notice.status === "seated"
    ? t("ordering.reservationNotice.seated", {
        table: tableName,
        guest: notice.guestName,
        time: clockOf(notice.seatedAt ?? notice.startAt),
      })
    : t("ordering.reservationNotice.upcoming", {
        table: tableName,
        guest: notice.guestName,
        time: clockOf(notice.startAt),
        count: notice.guests,
      });
